import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  position: relative;

  width: 100%;
  height: auto;
  padding: 0.75rem;

  margin-bottom: 1rem;
  border-radius: 0.5rem;
  border: 2px solid #F3F3F5;

  ${({ disabled }) => disabled && `
    background-color: #F3F3F5;
    pointer-events: none;
    user-select: none;
  `}

  .wrapper {
    display: flex;
    position: relative;
  
    .icons {
      z-index: 10;
      padding-inline: 0.5rem;
      background-color: white;
      
      gap: 1rem;
      display: flex;
      transition: opacity 0.3s ease, transform 0.3s ease;

      img {
        width: 1rem; 
        cursor: pointer;
      }
    }

    /* &:hover {
      .icons {
        position: absolute;
        opacity: 1;
      }
    } */

    @media (max-width: 1404px) {
      gap: 1rem;
      flex-direction: column;
    }
  }
`;

export const PrimarySection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .headerGroup {
    display: flex;
    justify-content: space-between;

    .date{
      gap: 1rem;
      display: flex;
      align-items: center;
    }
  }

  .cancelado {
    width: fit-content;
    padding: 0.375rem 0.5rem;
    align-self: self-end;

    margin-top: 0.5rem;
    
    border-radius: 62.4375rem;
    background-color: #FF525214;

    >div {
      display: flex;
      align-items: center;
      gap: 0.3125rem
    }
  }

  .sectionOne {
    width: 100%;
    gap: 0.5rem;
    display: flex;
    flex-direction: column;

    .date { 
      padding: 0.3125rem 0;
    }

    .ingredient {
      padding: 0.3125rem 0;
    }
  }

  .productBlock {
    width: 100%;

    display: flex;
    justify-content: space-between;
  }

  .pragaScroll {
    max-width: 250px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 4px;
      -webkit-appearance: none;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(31, 41, 55, 0.35);
      border-radius: 4px;
    }
  }

  // No mobile, empilha .left/.right (produto+ingrediente em cima, empresa+
  // praga embaixo) em vez de lado a lado - a coluna .right vem com
  // minWidth:fit-content e alignItems:flex-end via style inline (index.js),
  // que nunca encolhe pra caber ao lado de .left numa tela estreita: a
  // pílula da praga (.pragaScroll, que também tinha max-width fixo de
  // 250px, maior que o espaço sobrando) saía da tela, cortada na borda
  // direita. !important porque está sobrepondo estilo inline, que tem
  // prioridade maior que uma regra de classe normal.
  @media (max-width: 760px) {
    // Mesmo 0.75rem do .productBlock logo abaixo - sem isso, .headerGroup/
    // .sectionOne/Badges/.cancelado (filhos diretos deste PrimarySection)
    // ficam colados um no outro (nenhum gap aqui antes, cada um dependia só
    // do próprio padding interno pra respirar), bem mais apertado que o
    // espaço entre os blocos de dentro do .productBlock.
    gap: 0.75rem;

    .productBlock {
      flex-direction: column;
      gap: 0.75rem;
    }

    .productBlock .right {
      width: 100% !important;
      min-width: 0 !important;
      align-items: flex-start !important;
      text-align: left !important;
    }

    // marginBottom:0.5rem inline (index.js) no .left - no desktop (lado a
    // lado com .right) é inofensivo, mas empilhado aqui ele soma com o gap
    // de 0.75rem do .productBlock acima, abrindo mais espaço entre produto e
    // empresa/praga do que entre as outras seções. !important por ser
    // inline.
    .productBlock .left {
      margin-bottom: 0 !important;
    }

    .pragaScroll {
      max-width: 100%;
    }
  }

  .praga {
    padding: 0.25rem 0.5rem;
    gap: 0.25rem;
    width: fit-content;
    display: flex;
    align-items: center;
    border-radius: 62.4375rem;
    background-color: ${({ disabled }) => disabled ? `${theme.colors.disabled.Desabilitado_Claro}` : '#FF525214'};

    img {
      flex-shrink: 0;
      filter: ${({ disabled }) => disabled ? 'invert(1) brightness(10)' : ''};
    }
  }
`;

export const Badges = styled.div`
  gap: 1rem;
  display: flex;
  position: relative;
  align-items: center;

  // Sem efeito nenhum aqui (display:contents não gera caixa própria) - só
  // vira um scroll container de verdade no mobile (ver @media abaixo), pra
  // não mudar nada do layout atual lado a lado no desktop.
  .badgeScroll {
    display: contents;
  }

  .farm {
    max-width: 8.125rem;
    padding: 0.25rem 0.375rem;
    gap: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ disabled }) => disabled ? `${theme.colors.disabled.Desabilitado_Claro}` : '#F3F3F5'};
    border-radius: 62.4375rem;

    img {
      filter: ${({ disabled }) => disabled ? 'grayscale(1) brightness(4)' : ''};
    }

    p {
      max-width: 100%;
      color: ${({ disabled }) => disabled ? '#FFFFFF' : 'inherit'};
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
      text-overflow: ellipsis;
    }
  }

  .produtor {
    max-width: 9rem;
    max-height: 1.5rem;
    padding: 0.3125rem 0.5rem;
    border-radius: 62.4375rem;
    background-color: ${({ disabled }) => disabled ? `${theme.colors.disabled.Desabilitado_Claro}` : `${theme.colors.blue.Azul_link}`};
    
    p {
      max-width: 100%;
      color: #FFFFFF;
      overflow: hidden;
      line-height: 1rem;
      white-space: nowrap;
      display: inline-block;
      text-overflow: ellipsis;
    }
  }

  .cultura {
    width: fit-content;
    padding: 0.3125rem 0.5rem;
    border-radius: 62.4375rem;
    background-color: ${({ disabled }) => disabled ? `${theme.colors.disabled.Desabilitado_Claro}` : '#21262F'};
    
    p {
      color: #FFFFFF;
      white-space: nowrap;
    }
  }

  .user {
    max-width: 11rem;
    padding: 0.25rem 0.5rem;
    gap: 0.25rem;
    display: flex;
    align-items: center;
    border-radius: 62.4375rem;
    background-color: ${({ disabled }) => disabled ? `${theme.colors.disabled.Desabilitado_Claro}` : '#E9ECF0'};
    
    img {
      filter: ${({ disabled }) => disabled ? 'invert(1) brightness(4)' : ''};
    }

    p {
      max-width: 100%;
      color: ${({ disabled }) => disabled ? '#FFFFFF' : 'inherit'};
      overflow: hidden;
      line-height: 1rem;
      white-space: nowrap;
      display: inline-block;
      text-overflow: ellipsis;
    }
  }

  .nome-art {
    text-wrap: nowrap;
  }

  @media (max-width: 872px) {
    align-items: start;
    flex-direction: column;
    // Mesmo gap do .productBlock empilhado no mobile (ver @media 760px
    // acima) - 1rem (herdado do desktop, onde os badges ficam lado a lado)
    // deixava mais espaço entre cada badge empilhado do que entre
    // produto/ingrediente e empresa/praga logo acima, uma respiração
    // diferente sem motivo entre dois blocos de informação parecidos.
    gap: 0.75rem;

    // Conteúdo completo (não mais cortado com "...") nesses 3 badges - no
    // desktop o max-width (8.125rem/9rem/11rem) e a elipse existem porque
    // vários badges dividem espaço lado a lado numa linha só; empilhados no
    // mobile, cada um já tem o card inteiro pra si, então cortar o nome do
    // produtor/fazenda/responsável não faz mais sentido. Quando o texto
    // ainda assim for mais largo que o card, rola - mas quem rola é o
    // .badgeScroll por fora (ver abaixo), não a bolha arredondada em si: um
    // scroll direto num elemento com border-radius:62.4375rem faz a barra de
    // rolagem nativa (sempre retangular) furar o canto arredondado, sobrando
    // uma pontinha cinza saindo da bolha - mesmo problema que o
    // .pragaScroll/.praga acima já resolve com esse wrapper por fora.
    .badgeScroll {
      display: block;
      max-width: 100%;
      overflow-x: auto;

      &::-webkit-scrollbar {
        height: 3px;
        -webkit-appearance: none;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(31, 41, 55, 0.35);
        border-radius: 4px;
      }
    }

    .produtor, .farm, .user {
      max-width: none;
      width: fit-content;

      p {
        max-width: none;
        overflow: visible;
        text-overflow: unset;
      }
    }

    // .cultura já não corta (sem max-width/ellipsis no desktop) - só
    // garante que também usa a largura do card, igual aos outros 3.
    .cultura {
      max-width: 100%;
    }
  }
`;

export const SecondSection = styled.div`
  width: 100%;
  gap: 0.5rem;
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  hr {
    width: 100%;
    border: 1px solid;
    border-color: rgba(0,0,0,0.1);
    margin-top: 0.9rem;
  }

  hr:nth-child(odd) {
    margin-top: 0.3rem;
  }

  .headerSection {
    gap: 1rem;
    display: flex;
    align-items: center;
  }

  .praga {
    padding: 0.25rem 0.5rem;
    gap: 0.25rem;
    display: flex;
    align-items: center;
    border-radius: 62.4375rem;
    background-color: ${({ disabled }) => disabled ? `${theme.colors.disabled.Desabilitado_Claro}` : '#FF525214'};
    
    p {
      color:${({ disabled }) => disabled ? '#FFFFFF' : `${theme.colors.red.Tostado}`} ;
    }
  }

`

export const Icons = styled.div``;

export const ContainerNumeroArt = styled.div`
  width: auto;
  height: auto;

  gap: 1rem;
  display: flex;

  @media (max-width: 760px) {
    flex-direction: column;
  }
`;

export const ContainerIcons = styled.div`
  width: auto;
  height: auto;

  gap: 1rem;
  display: flex;

  >img{
    width: 1rem;
    height: auto;
    cursor: pointer;
  }
`;

export const StatusButton = styled.button`
    all: unset;

    padding: 0.25rem 0.5rem;
    gap: 0.25rem;
    display: ${({ disabled }) => disabled ? 'none' : 'flex'};
    align-items: center;
    border-radius: 62.4375rem;
    background-color: #F89E4B14;
`;